export default __webpack_public_path__ + "static/media/proectiroviecspl.68441ede.pdf";